
import Vue from 'vue'
import axios from 'axios'
import { Prop, Component } from 'vue-property-decorator'
import { CorrectiveAction, Dispute } from '../../global/models'
import { VForm } from '../../global/vuetify.types'

@Component
export default class DisputeDetail extends Vue {
  @Prop({ type: Object, required: true })
  private readonly dispute!: Dispute

  isEdittingAction = false

  correctiveActions: CorrectiveAction[] = []

  get canEditAction() {
    return this.dispute.status === 'under-consideration'
  }

  get customerRoute() {
    return { name: 'customers-read', params: { id: this.dispute.userId.toString() } }
  }

  get providerRoute() {
    return { name: 'providers-read', params: { id: this.dispute.providerId.toString() } }
  }

  get actionForm() {
    return this.$refs.form as VForm
  }

  async editAction() {
    if (!this.canEditAction) {
      return
    }
    const response = await axios.get<CorrectiveAction[]>('/disputes/corrective-actions')
    this.correctiveActions = response.data
    this.isEdittingAction = true
  }

  async saveAction() {
    if (!this.canEditAction) {
      return
    }
    if (this.actionForm.validate()) {
      await axios.put(`disputes/${this.dispute.id}`, this.dispute)
      this.$emit('reload')
      this.isEdittingAction = false
    }
  }
}
